function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledMobileBackgroundImageCard } from "./mobile-background-image-cards.scss";
import classnames from "classnames";
import AssetComponent from "components/core/asset/asset-component";
import CardButton from "../card-button/card-button";
const DEFAULT_PARAGRAPH = {
    topic: {}
};
const MobileBackgroundImageCard = ({ mobileBackgroundImage, backgroundImage, paragraph, fullParagraphAdvancedConfig, button, horizontalPadding })=>/*#__PURE__*/ _jsxs(StyledMobileBackgroundImageCard, {
        horizontalPadding: horizontalPadding,
        className: classnames("mobile-background-image-card"),
        children: [
            /*#__PURE__*/ _jsx(AssetComponent, {
                image: {
                    src: mobileBackgroundImage || backgroundImage
                },
                className: "mobile-card-image"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "details-wrapper",
                style: {
                    marginTop: fullParagraphAdvancedConfig === null || fullParagraphAdvancedConfig === void 0 ? void 0 : fullParagraphAdvancedConfig.marginTop
                },
                children: [
                    /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraphAdvancedConfig, DEFAULT_PARAGRAPH, paragraph), {
                        titleClassName: "card-title"
                    })),
                    (button === null || button === void 0 ? void 0 : button.buttonType) && /*#__PURE__*/ _jsx(CardButton, _object_spread({}, button))
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card-image"
            })
        ]
    });
export default MobileBackgroundImageCard;
